import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter, HostListener } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { SocialLearningService } from 'src/app/_services';
import { CommunicationsPostTypes, CommunicationsPostActions } from 'src/app/_enums';
import { SocialLearningPostGet, PostGetResult } from 'src/app/_models';
import { PostViewerLikeViewComponent } from './modal/post-viewer-like-view/post-viewer-like-view.component';
import { modalConfigurationSmall, modalConfigurationWithBackClickClose } from 'src/app/_configs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PostEditComponent } from '../modal/post-edit/post-edit.component';

@Component({
  selector: 'app-post-viewer',
  templateUrl: './post-viewer.component.html',
  styleUrls: ['./post-viewer.component.scss']
})
export class PostViewerComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  sectionSubjectId: number = null;
  @Input()
  postType: number = CommunicationsPostTypes.private;
  @Input()
  posts: SocialLearningPostGet = {
    results: [],
    totalRecords: 0
  };
  @Output()
  postsEmitter: EventEmitter<SocialLearningPostGet> = new EventEmitter<SocialLearningPostGet>();
  pageSize = 5;
  pageIndex = 1;
  openedComments: number[] = [];
  isLoading: boolean = false;
  isUpdatingLike: number[] = [];
  modalRef: BsModalRef;
  constructor(private socialLearningService: SocialLearningService, private modalService: BsModalService) {
    super();
  }

  ngOnInit() {
    this.getPosts();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sectionSubjectId) {
      this.pageIndex = 1;
      this.posts.totalRecords = 0;
      this.getPosts();
    }
  }
  getPosts(): void {
    if (this.postType === CommunicationsPostTypes.private) this.getPrivatePosts();
    else this.getPublicPosts();
  }
  getPrivatePosts(): void {
    this.isLoading = true;
    this.socialLearningService.GetPrivatePost(this.sectionSubjectId, this.pageSize, this.pageIndex).subscribe(
      (data: SocialLearningPostGet) => {
        if (this.pageIndex === 1) {
          this.posts = data;
        } else {
          data.results.map(item => {
            this.posts.results.push(item);
          });
          this.posts.totalRecords = data.totalRecords;
        }
        this.isLoading = false;
        this.postsEmitter.emit(this.posts);
      },
      () => {
        this.postsEmitter.emit(this.posts);
        this.isLoading = false;
      }
    );
  }
  getPublicPosts(): void {
    this.isLoading = true;
    this.socialLearningService.GetPublicPost(this.sectionSubjectId, this.pageSize, this.pageIndex).subscribe(
      (data: SocialLearningPostGet) => {
        data.results.map(item => {
          item.postFiles = [];
          item.postImages = [];
          item.postAttachments.map(subItem => {
            if (subItem.attachmentMimeType && subItem.attachmentMimeType.includes('image')) item.postImages.push(subItem);
            else item.postFiles.push(subItem);
          });
        });
        if (this.pageIndex === 1) {
          this.posts = data;
        } else {
          data.results.map(item => {
            this.posts.results.push(item);
          });
          this.posts.totalRecords = data.totalRecords;
        }
        this.isLoading = false;
        this.postsEmitter.emit(this.posts);
      },
      () => {
        this.postsEmitter.emit(this.posts);
        this.isLoading = false;
      }
    );
  }
  getSenderImage(imageUrl: string): string {
    return imageUrl ? this.getImage(imageUrl) : '../../assets/Images/users/default-user.jpg';
  }
  createLike(postItemId: number, postId: number): void {
    this.isUpdatingLike.push(postId);
    this.socialLearningService.LikePost(postItemId).subscribe(
      (data: { likes: number }) => {
        const postIndex = this.posts.results.findIndex(item => item.postId === postId);
        const updatingIndex = this.isUpdatingLike.findIndex(item => item === postId);
        if (postIndex !== -1) {
          this.posts.results[postIndex].isLikeByMe = true;
          this.posts.results[postIndex].likes = data.likes;
          this.postsEmitter.emit(this.posts);
        }
        if (updatingIndex !== -1) this.isUpdatingLike.splice(updatingIndex, 1);
      },
      () => {
        const updatingIndex = this.isUpdatingLike.findIndex(item => item === postId);
        if (updatingIndex !== -1) this.isUpdatingLike.splice(updatingIndex, 1);
      }
    );
  }
  deleteLike(postItemId: number, postId: number): void {
    this.isUpdatingLike.push(postId);
    this.socialLearningService.DeleteLikePost(postItemId).subscribe(
      (data: { likes: number }) => {
        const postIndex = this.posts.results.findIndex(item => item.postId === postId);
        const updatingIndex = this.isUpdatingLike.findIndex(item => item === postId);
        if (postIndex !== -1) {
          this.posts.results[postIndex].isLikeByMe = false;
          this.posts.results[postIndex].likes = data.likes;
          this.postsEmitter.emit(this.posts);
        }
        if (updatingIndex !== -1) this.isUpdatingLike.splice(updatingIndex, 1);
      },
      () => {
        const updatingIndex = this.isUpdatingLike.findIndex(item => item === postId);
        if (updatingIndex !== -1) this.isUpdatingLike.splice(updatingIndex, 1);
      }
    );
  }
  updateLike(isLikeByMe: boolean, postItemId: number, postId: number): void {
    if (!isLikeByMe) this.createLike(postItemId, postId);
    else this.deleteLike(postItemId, postId);
  }
  getIsActiveLike(postId: number): boolean {
    return this.isUpdatingLike.findIndex(item => item === postId) !== -1;
  }
  postCommentAdded(postId: number): void {
    const postIndex = this.posts.results.findIndex(item => item.postId === postId);
    if (postIndex !== -1) this.posts.results[postIndex].comments += 1;
    this.postsEmitter.emit(this.posts);
  }
  postCommentDeleted(postId: number): void {
    const postIndex = this.posts.results.findIndex(item => item.postId === postId);
    if (postIndex !== -1) this.posts.results[postIndex].comments -= 1;
    this.postsEmitter.emit(this.posts);
  }
  postAction(communicationsPostAction: number, postId: number): void {
    if (communicationsPostAction === CommunicationsPostActions.Edit) this.postEdit(postId);
    else if (communicationsPostAction === CommunicationsPostActions.Inactive) this.postInactive(postId);
    else if (communicationsPostAction === CommunicationsPostActions.Active) this.postActive(postId);
    else if (communicationsPostAction === CommunicationsPostActions.Delete) this.postDelete(postId);
  }
  postEdit(postId: number): void {
    const post: PostGetResult = this.posts.results.find(item => item.postId === postId);
    const initialState = { post };
    this.modalRef = this.modalService.show(PostEditComponent, {
      animated: true,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-dialog-centered model-dialog  modal-lg',
      initialState
    });
    this.modalRef.content.saving.subscribe((data: PostGetResult) => {
      const postIndex: number = this.posts.results.findIndex(item => item.postId === postId);
      if (postIndex !== -1) this.posts.results[postIndex] = data;
      this.postsEmitter.emit(this.posts);
    });
  }
  postInactive(postId: number): void {
    this.socialLearningService.DeActivePostOrReActivePost(postId).subscribe(() => {
      const postIndex = this.posts.results.findIndex(item => item.postId === postId);
      if (postIndex !== -1) this.posts.results[postIndex].isActive = false;
      this.postsEmitter.emit(this.posts);
    });
  }
  postActive(postId: number): void {
    this.socialLearningService.DeActivePostOrReActivePost(postId).subscribe(() => {
      const postIndex = this.posts.results.findIndex(item => item.postId === postId);
      if (postIndex !== -1) this.posts.results[postIndex].isActive = true;
      this.postsEmitter.emit(this.posts);
    });
  }
  postDelete(postId: number): void {
    const callback = () => {
      this.socialLearningService.DeletePost(postId).subscribe(() => {
        const postIndex = this.posts.results.findIndex(item => item.postId === postId);
        if (postIndex !== -1) {
          this.posts.results.splice(postIndex, 1);
          this.posts.totalRecords -= 1;
          this.postsEmitter.emit(this.posts);
        }
      });
    };
    this.showConfirmYesNoMessage('Common.AreYouSureYouWantToDeleteThisPost?', 'Common.DeletePost', callback);
  }
  showLikes(postItemId: number, likes: number): void {
    if (likes > 0) {
      const initialState = { postItemId };
      this.modalRef = this.modalService.show(PostViewerLikeViewComponent, {
        ...modalConfigurationSmall,
        initialState
      });
    }
  }
  showViews(postItemId: number, views: number): void {
    if (views > 0) {
      const initialState = { postItemId, isView: true };
      this.modalRef = this.modalService.show(PostViewerLikeViewComponent, {
        ...modalConfigurationSmall,
        initialState
      });
    }
  }
  showComments(postId: number): void {
    if (this.openedComments.findIndex(item => item === postId) === -1) this.openedComments.push(postId);
  }
  getOpenedComments(postId: number): boolean {
    return this.openedComments.findIndex(item => item === postId) !== -1;
  }
  @HostListener('document:scroll')
  onScroll(): void {
    const pos = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
    const max = document.documentElement.scrollHeight;
    if (pos === max) {
      if (this.posts.results.length < this.posts.totalRecords) {
        this.pageIndex += 1;
        this.getPosts();
      }
    }
  }
}
